import {
  Component,
  DoCheck, EventEmitter,
  Input,
  IterableDiffers,
  OnInit, Output,
} from '@angular/core';
import { IDataTableAction } from './models/data-table-action.interface';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'upsc-data-table',
  template: '',
})
export class DataTableComponent<T> implements OnInit, DoCheck {
  @Input() items: T[];
  @Input() displayedColumns = [];
  @Input() footerItems = [];
  @Output() rowActionClicked: EventEmitter<IDataTableAction<T>> = new EventEmitter<IDataTableAction<T>>();

  public dataSource: MatTableDataSource<T> | null;
  public footerDataSource: any[];

  private iterableDiffers;

  constructor(private _iterableDiffers: IterableDiffers) {
    this.iterableDiffers = this._iterableDiffers.find([]).create(null);
  }

  public ngDoCheck() {
    const ItemsChanges = this.iterableDiffers.diff(this.items);
    if (ItemsChanges) {
      this.dataSource = new MatTableDataSource(<T[]>(ItemsChanges.collection));
    }

    const footerItemsChanges = this.iterableDiffers.diff(this.footerItems);
    if (footerItemsChanges) {
      this.footerDataSource = footerItemsChanges.collection;
    }
  }

  public ngOnInit() {
  }
}
